import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { TRCFundClasses } from 'app/shared/models/tRCFundClasses.model';
import * as moment from 'moment';

@Component({
  selector: 'jhi-eappreg-trc',
  templateUrl: './eappreg-trc.component.html',
  styleUrls: ['./eappreg-trc.component.scss']
})
export class EappregTrcComponent implements OnInit {
  eappRegConsts = BUSINESS_REG_APP_CONSTANT
  TRCAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "");
  TRCTotalTaxDue = Number(sessionStorage.getItem("TRCTotalTaxDue") ?? "0")
  maLine1 = ""
// INC0754669 - Enhancement - PFA EappReg - Adding GGR
  Ggr = Number(sessionStorage.getItem("GGR"))
  // add 6 months
  expDate:any
	RevTypesList : TRCFundClasses[] = JSON.parse(sessionStorage.getItem("TRCFundClasses") ?? "[]")
	 //RevTypes: TRCFundClasses[]=[]
  constructor(private elRef: ElementRef,
    private router: Router,
    private businessRegAppService: BussinessRegAppService) {
	if(sessionStorage.getItem("prev_page") === "payment"){
      this.router.navigate(['/warning_page'])
      return;
    }
    // empty
  }

  ngOnInit(): void {
    this.TRCAppForm.busact_Start_Dt = moment(this.TRCAppForm.busact_Start_Dt).utc().format('MM/DD/YYYY')
    // empty
    const expiration = new Date(this.TRCAppForm.postMarkDt)
    this.expDate = expiration.setMonth(expiration.getMonth()+6)
    this.maLine1 = this.TRCAppForm.mA2_Unit_Type === 'POBX' ? "POST OFFICE BOX ".concat(this.TRCAppForm.ma2_Unit_Nbr) : `${String(this.TRCAppForm.ma1_Str_Nbr)} ${String(this.TRCAppForm.ma1_Str_Nbr_Frac)} ${String(this.TRCAppForm.ma1_Str_Nm)} ${String(sessionStorage.getItem("TRCqMAStreetType")??"")} ${String(sessionStorage.getItem("TRCMailUnitTypeDesc")??"")} ${String(this.TRCAppForm.ma2_Unit_Nbr)}`
	//this.RevTypes = this.RevTypesList.filter((obj) =>  obj.measure >0);
  }
  print(): void {
    window.print();
  }

  submit(): void {
    if (this.TRCAppForm.filer_Email !== "") {
      const body = `${String(this.elRef.nativeElement.querySelector('#sendmail').outerHTML)}
      <br/>
      <p align="center">*** PLEASE DO NOT REPLY TO THIS EMAIL ADDRESS ***</p>
     <p align="center">***  YOUR EMAIL WILL NOT BE DELIVERED OR READ  ***</p>
     <p align="center" id="contact">If you require assistance, please e-mail 
     <A href = "mailto:Finance.CustomerService@lacity.org">Finance.CustomerService@lacity.org</A>
      or call our Customer Service Center at (844) 663-4411, Mondays through Thursdays 9:00 a.m. - 3:00 p.m. and Fridays 9:00 a.m. - 2:00 p.m.</p>
      <br />
      <p align="left">Thank you, </p>
      <p align="left">Office of Finance</p>`
      this.businessRegAppService.sendReceiptEmail({
        "toAddress": this.TRCAppForm.filer_Email,
        "body":`${body}`,
        "subject":`${String(sessionStorage.getItem("TRCReceiptType")??"")} Confirmation Letter`
      }).subscribe()
    }
    if(this.TRCTotalTaxDue > 0){
      const urldata = `WebFilingID=${String(this.TRCAppForm.web_Filing_Id)}&AcctNbr=${String(this.TRCAppForm.location_Acct_Number)}&TotAmtDue=${String(this.TRCTotalTaxDue)}&PageHeader=${String(this.eappRegConsts.PageHeader)}&ItemSrcType=${String(this.eappRegConsts.ItemSrcType)}&ReceiptPage=${String(this.eappRegConsts.ReceiptPage)}&StartPage=${String(this.eappRegConsts.StartPage)}`;
      this.businessRegAppService.getpreviewdata(urldata).subscribe((res: any) => {
        const encrytedUrl = encodeURI(res);
		sessionStorage.setItem("prev_page","payment")
        sessionStorage.setItem("paymentUrl", `${String(this.eappRegConsts.paymentUrl)}${String(encrytedUrl)}`)
        window.open(`${String(this.eappRegConsts.paymentUrl)}${String(encrytedUrl)}`, "_self");
      });
    }else{
      this.router.navigate(['/eappreg_receipt'])
    }
    
  }

  get sessionStorage() : any {
    return sessionStorage ;
  }
}
